module.exports = __webpack_public_path__ + "media/images/dashboard-9d71eaa954a6259fbce7ca58fb987084.png";